import { commonMessages } from '../../util/messages'

export const messages = {
  common: commonMessages,
  marketIndex: {
    list: {
      error: 'There is a problem retrieving the market indexes',
    },
    create: {
      error: 'There is a problem creating the market index',
      success: 'Market Index created successfully',
    },
    retrieve: {
      error: 'There is a problem retrieving the market index details',
    },
    update: {
      error: 'There is a problem updating the market index',
      success: 'Market Index updated successfully',
    },
    delete: {
      success: 'Market Index deleted successfully',
      error: 'There is a problem deleting the market index',
    },
  },
}
